import { ORGANIZATION_ASSISTANT_CAMPAIGN_TYPES, OrganizationAssistantCampaignType } from "@simplyk/common";

import { isRecord } from "./isRecord";

export const readCampaignType = (output: unknown): OrganizationAssistantCampaignType | null =>
  isRecord(output) && isCampaignType(output.campaignType) ? output.campaignType : null;

const isCampaignType = (value: unknown): value is OrganizationAssistantCampaignType =>
  typeof value === "string" && (ORGANIZATION_ASSISTANT_CAMPAIGN_TYPES as readonly string[]).includes(value);
